import { request } from './client';
import {
  ImportFormat,
  ImportPreviewResponse,
  ImportCommitPayload,
  ImportCommitResponse,
} from '../types/import';

export async function uploadImportPreview(
  file: File,
  format: ImportFormat = 'auto',
  deck_id?: string
): Promise<ImportPreviewResponse> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('format', format);
  if (deck_id) {
    formData.append('deck_id', deck_id);
  }

  return request<ImportPreviewResponse>('/imports/preview', {
    method: 'POST',
    body: formData,
  });
}

export async function commitImport(
  import_id: string,
  payload: ImportCommitPayload
): Promise<ImportCommitResponse> {
  return request<ImportCommitResponse>(
    `/imports/${encodeURIComponent(import_id)}/commit`,
    {
      method: 'POST',
      body: JSON.stringify(payload),
    }
  );
}
